/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Freealerts1Inputs */

const he_home_trust_freealerts1 = /** @type {(inputs: Home_Trust_Freealerts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות על ירידת שינויי מחיר`)
};

const en_home_trust_freealerts1 = /** @type {(inputs: Home_Trust_Freealerts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free alerts`)
};

/**
* | output |
* | --- |
* | "Free alerts" |
*
* @param {Home_Trust_Freealerts1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const home_trust_freealerts1 = /** @type {((inputs?: Home_Trust_Freealerts1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Freealerts1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_trust_freealerts1(inputs)
	return en_home_trust_freealerts1(inputs)
});
export { home_trust_freealerts1 as "home_trust_freeAlerts" }